module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Centre_Alignment__And__Left_Indent__And__Right_Indent__And__Page_Break"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("TO")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Centre_Alignment__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("P.H.K-K.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Centre_Alignment__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("P.B., M.T, E.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc0bf46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0003.vue
// module id = 66
// module chunks = 0